import request from '../../lib/helpers/requestApi';
import { THistoryResponse, THistoryParams } from './types';

export const getHistoryList = request<THistoryResponse[], THistoryParams>({
  method: 'history.getList',
});
